import { ReferralStatus } from '../schemas';

export const referalFinalStatuses = [
  ReferralStatus.completed,
  ReferralStatus.cancelled,
];

export const referralStatuses = Object.values(ReferralStatus);
